module.exports = __webpack_public_path__ + "static/media/kitchens.8afa311c.jpg";